var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#021546","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},[React.createElement("path",{"d":"m17.5801 1.38306c-5.0844.04257-10.16876.08514-15.25314.12772","key":0}),React.createElement("path",{"d":"m20.3037 7.07651c-4.9002-.03201-8.8029-.13378-13.7031-.16579","key":1}),React.createElement("path",{"d":"m18.4775 12.6497c-5.2318.0345-11.46115.1388-16.69297.1734","key":2})]));
}

MenuInline.defaultProps = {"fill":"none","height":"15","viewBox":"0 0 22 15","width":"22"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
